"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const react_query_1 = require("@tanstack/react-query");
const antd_1 = require("antd");
const NewTenant_1 = __importDefault(require("./NewTenant"));
const ManageTenant_1 = __importDefault(require("./ManageTenant"));
const DomainController_1 = __importDefault(require("../DomainController"));
const tenants_1 = require("../../services/tenants");
const queryKeys_1 = __importDefault(require("../../constants/queryKeys"));
const handleRecordAction = (text, _a) => {
    var { tenantId, isBaseTenant } = _a, rest = __rest(_a, ["tenantId", "isBaseTenant"]);
    return ((0, jsx_runtime_1.jsxs)(react_router_dom_1.Link, Object.assign({ to: `/tenants/manage/${tenantId}`, state: Object.assign({ tenantId, isBaseTenant }, rest) }, { children: [text, " ", isBaseTenant && (0, jsx_runtime_1.jsx)(antd_1.Tag, Object.assign({ color: 'green' }, { children: "BASE" }))] }), tenantId));
};
const columns = [
    { title: 'Name', dataIndex: 'tenantName', key: 'tenantName', render: handleRecordAction },
    { title: 'Tenant ID', dataIndex: 'tenantId', key: 'tenantId' },
    { title: 'Active', dataIndex: 'isActive', key: 'isActive',
        render: (flag) => (flag ? 'Yes' : 'No'),
    },
];
const Tenants = () => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { isLoading, data } = (0, react_query_1.useQuery)([queryKeys_1.default.TENANTS.ALL], (0, tenants_1.getTenants)(), {
        onError: (err) => {
            const { status, data: { msg } } = err.response;
            switch (status) {
                case 404: return navigate('/tenants/404', { state: { comingFrom: '' } });
                case 500: return navigate('/tenants/500');
                default: antd_1.message.error(msg);
            }
        },
    });
    const newData = data === null || data === void 0 ? void 0 : data.filter(({ isActive }) => isActive);
    return ((0, jsx_runtime_1.jsx)(DomainController_1.default, { apiContext: '/tenants', urlPath: '/tenants', loading: isLoading, columns: columns, data: newData, title: 'Tenants', componentForNew: (0, jsx_runtime_1.jsx)(NewTenant_1.default, {}), componentForManage: (0, jsx_runtime_1.jsx)(ManageTenant_1.default, {}), primaryKey: 'tenantId' }));
};
exports.default = Tenants;
